import { UserBetLimit } from '../../interfaces/api/user-limit.interface';

export const TOKEN_HEADER_KEY = 'x-api-key';
export const SKIP_ERROR_NOTIFICATION_HEADER = 'X-Skip-Error-Notification';
export const SKIP_AUTH_HEADER = 'skip';
export const USER_SESSION = 'USER_SESSION';
export const USER_SESSION_PRE = 'USER_SESSION_PRE';

export const LOCAL_STORAGE_NAMES = {
  LANGUAGE: 'Language',
  THEME: 'Theme',
};

export const AVAILABLE_LANGUAGES = {
  ES: 'es',
  EN: 'en',
} as const;

export const HORARY_ZONE = [
  { label: 'UTC−12:00', value: '-12' },
  { label: 'UTC−11:00', value: '-11' },
  { label: 'UTC−10:00', value: '-10' },
  { label: 'UTC−09:00', value: '-9' },
  { label: 'UTC−08:00', value: '-8' },
  { label: 'UTC−07:00', value: '-7' },
  { label: 'UTC−06:00', value: '-6' },
  { label: 'UTC−05:00', value: '-5' },
  { label: 'UTC−4:00', value: '-4' },
  { label: 'UTC−3:00', value: '-3' },
  { label: 'UTC−2:00', value: '-2' },
  { label: 'UTC−1:00', value: '-1' },
  { label: 'UTC-0:00', value: '0' },
  { label: 'UTC+1:00', value: '1' },
  { label: 'UTC+2:00', value: '2' },
  { label: 'UTC+3:00', value: '3' },
  { label: 'UTC+4:00', value: '4' },
  { label: 'UTC+5:00', value: '5' },
  { label: 'UTC+6:00', value: '6' },
  { label: 'UTC+7:00', value: '7' },
  { label: 'UTC+8:00', value: '8' },
  { label: 'UTC+9:00', value: '9' },
  { label: 'UTC+10:00', value: '10' },
  { label: 'UTC+11:00', value: '11' },
  { label: 'UTC+12:00', value: '12' },
  { label: 'UTC+13:00', value: '13' },
  { label: 'UTC+14:00', value: '14' },
];

export const TIME_ZONE = 'America/Guayaquil';

export const SELECT_TYPE = {
  COUNTRY: 'country',
  CURRENCY: 'currency',
  GENDER: 'gender',
  LANGUAGE: 'language',
  CITY: 'city',
  BONUS: 'bonus',
  USERS: 'users',
};

export const CHANGE_PASSWORD_CONSTANTS = {
  PASSWORD_FIELD: 'password',
  NEW_PASSWORD_FIELD: 'newPassword',
  CONFIRM_PASSWORD_FIELD: 'confirmPassword',
};

export const BALANCE_TYPE = {
  BALANCE: 'balance',
  CREDIT: 'credit',
};

export const USER_TYPE = {
  AGENT: 'Agents',
  COLABORATOR: 'Collaborator',
  COLLABORATOR_AGENT: 'CollaboratorAgent',
  PLAYER: 'Player',
  QUICK_PLAYER: 'QuickPlayer',
  ALL: 'All',
  AFFILIATE: 'Affiliate',
  CASHDESK: 'Cashdesks',
  ALL_COLLABORATORS: 'AllCollaborator',
  PLAYER_AFFILIATE: 'PlayerAffiliate',
  CREDIT_AGENT: 'CreditAgent',
};

export const USER_LOCK_STATE = {
  LOCKED: 1,
  UNLOCKED: 0,
};

export const TYPE_TRANSACTION = {
  DEPOSIT: 'Deposit',
  WITHDRAWAL: 'Withdrawal',
  CREDIT: 'Credit',
  CASH: 'Cash',
  BANKING: 'Banking',
  DIRECT: 'Direct',
  CORRECTION: 'Correction',
};

export const NAV_ITEM_STATE = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const BACK_OFFICE = 'Backoffice';

export const RECORD_SOURCE = {
  BACK_OFFICE: 'BackOffice',
} as const;

export const STATE_TRANSACTION = {
  PROCESSED: 'Processed',
  PENDING: 'Pending',
};
export const GENDER_OPTIONS = [
  { value: 'male', label: 'words.male' },
  { value: 'female', label: 'words.female' },
  { value: 'notDefined', label: 'words.notDefined' },
];

export const ORIGIN = {
  BACK_OFFICE: 'Backoffice',
  PLAYER: 'Players',
  CENTER: 'Center',
};

export const PAGE_CATEGORY = {
  CASINO: 'casino',
  SPORTBOOK: 'sportBook',
};

export const RELATIONAL_OPERATOR = {
  EQUAL: '=',
  EQUAL_ALT: '==',
  GT: '>',
  LT: '<',
  GTE: '>=',
  LTE: '<=',
  RANGE: 'range',
};

export const USER_SESSION_LOGIN = {
  CASHDESK: 'cashdesk',
  USER: 'user',
} as const;

export const PERMITTED_VIEWS = {
  DASHBOARD: 'dashboard',
  DASHBOARD_BETTING_OVERVIEW: 'bettingOverview',
  DASHBOARD_GENERAL_STATISTICS: 'generalStatistics',
  DASHBOARD_TOP_TABLES: 'topTables',
  DASHBOARD_TOP_TABLE_PLAYERS: 'topTablePlayers',
  DASHBOARD_TOP_TABLE_AGENTS: 'topTableAgents',
  DASHBOARD_TOP_TABLE_BONUSES: 'topTableBonuses',
  DASHBOARD_STATISTICS_AGENTS_TODAY: 'dashboardStatisticsAgentsToday',
  DASHBOARD_STATISTICS_AGENTS_THIS_MONTH: 'dashboardStatisticsAgentsThisMonth',
  DASHBOARD_STATISTICS_AGENTS_TOTAL: 'dashboardStatisticsAgentsTotal',
  DASHBOARD_STATISTICS_PLAYERS_TODAY: 'dashboardStatisticsPlayersToday',
  DASHBOARD_STATISTICS_PLAYERS_THIS_MONTH: 'dashboardStatisticsPlayersThisMonth',
  DASHBOARD_STATISTICS_PLAYERS_TOTAL: 'dashboardStatisticsPlayersTotal',
  DASHBOARD_STATISTICS_BETS_TODAY: 'dashboardStatisticsBetsToday',
  DASHBOARD_STATISTICS_BETS_THIS_MONTH: 'dashboardStatisticsBetsThisMonth',
  DASHBOARD_STATISTICS_ALL_CASH_DESK: 'dashboardStatisticsAllCashDesk',
  DASHBOARD_STATISTICS_MONTH_CASH_DESK: 'dashboardStatisticsMonthCashDesk',
  DASHBOARD_STATISTICS_TODAY_CASH_DESK: 'dashboardStatisticsTodayCashDesk',
  DASHBOARD_TOTAL_TYPE_BETS: 'dashboardTotalTypeBets',

  DIRECT_LOADS: 'directLoads',
  DIRECT_LOADS_ADMINISTRATIVE: 'directLoadsAdministrative',
  RESOLVE_PENDING_BETS: 'resolvePendingBets',
  SUPPORT: 'support',
  SUPPORT_ZGAMES_TICKETS: 'supportZgamesTickets',

  REQUESTS: 'requests',
  REQUESTS_DEPOSIT: 'requestsDeposit',
  REQUESTS_WITHDRAWAL: 'requestsWithdrawal',

  PLAYERS: 'players',
  PLAYER_LIST: 'playerList',
  PLAYERS_BLOCKED: 'playersBlocked',
  PLAYERS_TRANSFER: 'playersTransfer',
  PLAYERS_ACTIVE: 'playersActive',
  PROMOTIONAL_TOOLS: 'promotionalTools',
  PROMOTIONAL_TOOLS_BONUS: 'promotionalToolsBonus',
  PROMOTIONAL_TOOLS_CODES: 'promotionalToolsCodes',
  PROMOTIONAL_TOOLS_BONUS_INFO: 'promotionalToolsBonusInfo',
  FINANCIAL: 'financial',
  FINANCIAL_BANK_ENTITIES: 'financialBankEntities',
  FINANCIAL_HOLDERS: 'financialHolders',
  FINANCIAL_HOLDERS_COMPANIES: 'financialHoldersCompanies',
  FINANCIAL_HOLDERS_AGENTS: 'financialHoldersAgents',
  FINANCIAL_HOLDERS_PLAYERS: 'financialHoldersPlayers',
  FINANCIAL_HOLDERS_INACTIVE: 'financialHoldersInactive',
  FINANCIAL_HOLDERS_COMPANIES_VIEW: 'financialHoldersCompaniesView',
  FINANCIAL_HOLDERS_COMPANIES_EDIT: 'financialHoldersCompaniesEdit',
  FINANCIAL_HOLDERS_COMPANIES_DELETE: 'financialHoldersCompaniesDelete',
  FINANCIAL_HOLDERS_COMPANIES_DETAIL: 'financialHoldersCompaniesDetail',
  FINANCIAL_HOLDERS_AGENTS_VIEW: 'financialHoldersAgentsView',
  FINANCIAL_HOLDERS_AGENTS_EDIT: 'financialHoldersAgentsEdit',
  FINANCIAL_HOLDERS_AGENTS_DELETE: 'financialHoldersAgentsDelete',
  FINANCIAL_HOLDERS_PLAYERS_VIEW: 'financialHoldersPlayersView',
  FINANCIAL_HOLDERS_PLAYERS_EDIT: 'financialHoldersPlayersEdit',
  FINANCIAL_HOLDERS_PLAYERS_DELETE: 'financialHoldersPlayersDelete',
  FINANCIAL_HOLDERS_INACTIVE_RESTORE: 'financialHoldersInactiveRestore',
  FINANCIAL_HOLDERS_COMPANIES_INACTIVE: 'financialHoldersCompaniesInactive',
  FINANCIAL_HOLDERS_COMPANIES_INACTIVE_RESTORE: 'financialHoldersCompaniesInactiveRestore',
  FINANCIAL_TRANSACTIONS: 'financialTransactions',
  FINANCIAL_WITHDRAWAL_REQUEST: 'financialWithdrawalRequest',
  FINANCIAL_DEPOSIT_REQUEST: 'financialDepositRequest',
  TOOLS: 'tools',
  TOOLS_COMMISSION_PLANS: 'toolsCommissionPlans',
  TOOLS_RESTRICTIONS_IP_ADDRESS: 'toolsRestrictionsIpAddress',
  TOOLS_REFERAL_COMMISSION: 'referalCommission',
  USER_MANAGEMENT: 'userManagement',
  USER_MANAGEMENT_USERS: 'userManagementUsers',
  USER_MANAGEMENT_COLLABORATOR_AGENTS: 'userManagementCollaboratorAgents',
  USER_ACCOUNT_VIEW: 'userManagementAccountView',
  BTN_ADD_USER_NAV: 'addUserNav',
  BTN_ADD_AGENT: 'addAgent',
  BTN_ADD_PLAYER: 'addPlayer',
  BTN_ADD_QUICK_PLAYER: 'addQuickPlayer',
  BTN_ADD_COLLABORATOR: 'addCollaborator',
  BTN_ADD_COLLABORATOR_AGENT: 'addCollaboratorAgent',
  BTN_TRANSFER_NAV: 'transferBtnNav',
  BTN_TRANSFER_AGENT: 'transferAgent',
  BTN_TRANSFER_CREDIT_AGENT: 'transferCreditAgent',
  BTN_TRANSFER_PLAYER: 'transferPlayer',
  BTN_TRANSFER_PLAYER_BY_CODE: 'transferPlayerByCode',
  BTN_ADD_TRANSFER_CORRECTION: 'addTransferCorrection',
  BTN_TRANSFER_COLLABORATOR: 'transferCollaborator',
  BTN_CANCEL_BONUS: 'btnCancelBonus',
  BTN_VIEW_BONUS: 'btnViewBonus',
  VIEW_BALANCE_NAV: 'viewBalanceNav',
  VIEW_CREDITS_NAV: 'viewCreditsNav',
  USER_MANAGEMENT_COLLABORATORS: 'userManagementCollaborators',
  USER_MANAGEMENT_AGENTS: 'userManagementAgents',
  VERIFICATION_REQUEST: 'requestAffiliate',
  USER_MANAGEMENT_ROLES_PERMISSION: 'userManagementRolesPermission',
  SPORT_MANAGEMENT: 'sportManagement',
  SPORT_MANAGEMENT_BET_LIMIT: 'sportManagementBetLimit',
  SPORT_MANAGEMENT_BET_LIMIT_GLOBAL: 'sportManagementBetLimitGlobal',
  BET_LIMIT_GLOBAL_VIEW: 'betLimitGlobalView',
  BET_LIMIT_GLOBAL_EDIT: 'betLimitGlobalEdit',
  BET_LIMIT_GLOBAL_ADD: 'betLimitGlobalAdd',
  SPORT_MANAGEMENT_EVENT_MANAGER: 'sportManagementEventManager',
  SPORT_MANAGEMENT_EVENT_MANAGER_PREMATCH: 'sportManagementEventManagerPrematch',
  SPORT_MANAGEMENT_EVENT_MANAGER_LIVE: 'sportManagementEventManagerLive',

  CASINO_MANAGEMENT: 'casinoManagement',
  CASINO_MANAGEMENT_OPERATOR: 'casinoManagementOperator',
  CASINO_MANAGEMENT_PROVIDER: 'casinoManagementProvider',
  CASINO_MANAGEMENT_PROVIDER_EDIT: 'casinoManagementProviderEdit',
  CASINO_MANAGEMENT_GAMES: 'casinoManagementGames',
  CASINO_MANAGEMENT_SHOWCASE: 'casinoManagementShowcase',
  CASINO_MANAGEMENT_GAMES_STATE_BTN: 'casinoManagementGamesChangeState',

  PAGE_MANAGEMENT: 'pageManagement',
  PAGE_MANAGEMENT_TOURNAMENT: 'pageManagementTournament',
  PAGE_MANAGEMENT_SECTION: 'pageManagementSection',
  PAGE_MANAGEMENT_PROMOTION: 'pageManagementPromotion',
  PAGE_CONFIGURATION: 'pageConfiguration',
  PAGE_MANAGEMENT_FORMS: 'pageManagementForms',

  PAGE_CONFIGURATION_CODE_INYECTION: 'pageConfigurationCodeInyection',
  PAGE_CONFIGURATION_ABOUT_US: 'pageConfigurationAboutUs',
  PAGE_CONFIGURATION_PRIVACY_POLICY: 'pageConfigurationPrivacyPolicy',
  PAGE_CONFIGURATION_COOKIE_POLICY: 'pageConfigurationCookiePolicy',
  PAGE_CONFIGURATION_TERMS: 'pageConfigurationTermsAndConditions',
  PAGE_CONFIGURATION_GAMING: 'pageConfigurationResponsibleGaming',
  PAGE_CONFIGURATION_WHATSAPP: 'pageConfigurationWhatsAppMessage',
  PAGE_CONFIGURATION_FAQS: 'pageConfigurationFaqs',
  PAGE_CONFIGURATION_TUTORIALS: 'pageConfigurationTutorials',
  PAGE_CONFIGURATION_CONTACT: 'pageConfigurationContact',
  PAGE_CONFIGURATION_QUICK_ACCESS_MENU: 'pageConfigurationQuickAccessMenu',
  FOLLOW_YOUR_LUCK: 'puntoSortiCamino',
  REAL_TIME: 'realTime',
  REAL_TIME_JOURNEY: 'realTimeJourney',
  REAL_TIME_JOURNEY_VIEW: 'realTimeJourneyView',
  REAL_TIME_JOURNEY_CREATE: 'realTimeJourneyCreate',
  REAL_TIME_JOURNEY_EDIT: 'realTimeJourneyEdit',
  REAL_TIME_JOURNEY_TOGGLE_STATUS: 'realTimeJourneyToggleStatus',
  REAL_TIME_JOURNEY_METRICS: 'realTimeJourneyMetrics',
  BETSHOP_MANAGEMENT: 'betshopManagement',
  BETSHOP_MANAGEMENT_BETSHOP: 'betshopManagementBetshop',
  BETSHOP_MANAGEMENT_CASHDESK: 'betshopManagementCashdesk',
  REPORTS: 'reports',
  REPORTS_SPORTS_BETTING: 'reportsSportsBetting',
  REPORTS_SPORTS_BETTING_BETTING: 'reportsSportsBettingBetting',
  REPORTS_SPORTS_BETTING_SPORTS: 'reportsSportsBettingSports',
  REPORTS_SPORTS_BETTING_CATEGORIES: 'reportsSportsBettingCategories',
  REPORTS_SPORTS_BETTING_EVENTS: 'reportsSportsBettingEvents',
  REPORTS_SPORTS_BETTING_MARKETS: 'reportsSportsBettingMarkets',
  REPORTS_LOADS_AND_WITHDRAWALS: 'reportsLoadsAndWithdrawals',
  REPORTS_AGENTS_LIST_LOADS_AND_WITHDRAWALS: 'reportsAgentsListLoadsAndWithdrawals',
  REPORTS_PLAYERS_LIST_LOADS_AND_WITHDRAWALS: 'reportsPlayersListLoadsAndWithdrawals',
  REPORTS_COLLABORATORS_LIST_LOADS_AND_WITHDRAWALS: 'reportsCollaboratorsListLoadsAndWithdrawals',
  REPORTS_TRANSACTION_REPORTS: 'reportsTransactionReports',
  REPORTS_TRANSACTION_REPORTS_ALL_TRANSACTIONS: 'reportsTransactionAllTransactions',
  REPORTS_TRANSACTION_REPORTS_AGENTS: 'reportsLoadsAndWithdrawalsAgents',
  REPORTS_TRANSACTION_REPORTS_PLAYERS: 'reportsLoadsAndWithdrawalsPlayers',
  REPORTS_PHYSICAL_TRANSACTION_POINTS: 'reportsPhysicalTransactionPoints',
  REPORTS_PHYSICAL_TRANSACTION_POINTS_LOADS_WITHDRAWALS:
    'reportsPhysicalTransactionPointsLoadsWithdrawals',
  REPORTS_PHYSICAL_WITHDRAW_CODES_HISTORY: 'reportsPhysicalWithdrawCodesHistory',
  REPORTS_PHYSICAL_WITHDRAW_CODES_HISTORY_CANCEL: 'reportsPhysicalWithdrawCodesHistoryCancel',
  REPORTS_CASINO: 'reportsCasino',
  REPORTS_CASINO_BY_GAMES: 'reportsCasinoByGames',
  REPORTS_CASINO_BY_PARTNER: 'reportsCasinoByPartner',
  REPORTS_CASINO_BY_BETS: 'reportsCasinoByBets',
  REPORTS_CASINO_BY_PLAYER: 'reportsCasinoByPlayers',
  REPORTS_CASINO_BY_PROVIDER: 'reportsCasinoByProvider',
  REPORTS_DOWNLOAD_CENTER: 'reportsDownloadCenter',
  REPORTS_LIVE_CASINO: 'reportsLiveCasino',
  REPORTS_LIVE_CASINO_BY_GAMES: 'reportsLiveCasinoByGames',
  REPORTS_LIVE_CASINO_BY_CURRENCY: 'reportsLiveCasinoByCurrency',
  REPORTS_LIVE_CASINO_BY_BETS: 'reportsLiveCasinoByBets',
  REPORTS_LIVE_CASINO_BY_PLAYER: 'reportsLiveCasinoByPlayers',
  REPORTS_LIVE_CASINO_BY_PROVIDER: 'reportsLiveCasinoByProvider',
  VIRTUAL_BETS: 'virtualBet',
  REPORTS_VIRTUAL_BETS: 'reportsVirtualBet',
  REPORTS_BONUS_PROMOTIONAL_CODE: 'reportsBonusPromotionalCode',
  REPORTS_LOGIN_HISTORY: 'reportsLoginHistory',
  REPORTS_LOGIN_HISTORY_BACKOFFICE: 'reportsLoginHistoryBackoffice',
  REPORTS_LOGIN_HISTORY_PLAYER: 'reportsLoginHistoryPlayer',
  AFFILIATES: 'affiliates',
  AFFILIATES_ANALYTICS: 'affiliatesAnalytics',
  AFFILIATES_REFERRAL_LINK: 'affiliatesReferralLink',
  AFFILIATES_AGENTS_TREE: 'affiliatesAgentsTree',
  GENERAL_REPORTS: 'generalReports',
  GENERAL_PRODUCTS_REPORTS: 'generalProductsReports',
  GENERAL_USERS_REPORTS: 'generalUsersReports',
  GENERAL_PLAYERS_REPORTS: 'generalPlayersReports',
  GENERAL_AGENTS_DATAMART_REPORTS: 'generalAgentsDatamartReports',
  GENERAL_PLAYERS_DATAMART_REPORTS: 'generalPlayersDatamartReports',
  GENERAL_REPORTS_EXPORT_AGENT_DATAMART_BTN: 'generalReportsExportAgentDatamartBtn',
  GENERAL_REPORTS_EXPORT_PLAYER_DATAMART_BTN: 'generalReportsExportPlayerDatamartBtn',
  CHANGE_PASSWORD_ACTIVE_PLAYER: 'changePasswordActivePlayer',
  OPTIONAL_REQUIRED_CHANGE_PASSWORD: 'optionalRequiredChangePassword',
  SETTING_BTN_ACTIVE_PLAYER: 'viewSettingBtnActivePlayer',
  UNBLOCK_BTN_BLOCKED_PLAYER: 'viewUnblockBtnBlockedPlayer',
  MOVE_ACTIVE_PLAYER: 'moveActivePlayer',
  BLOCK_ACTIVE_PLAYER: 'blockActivePlayer',
  WRITE_NOTES_ACTIVE_PLAYER: 'writeNotesActivePlayer',
  PLAYER_ADD_BTN: 'viewPlayerAdd',
  PLAYER_EDIT_BTN: 'viewPlayerEdit',
  VIEW_PLAYER_SENSITIVE_DATA: 'viewPlayerSensitiveData',
  PLAYER_UNLOCK_BTN: 'viewPlayerUnlock',
  PLAYER_VERIFY_CHECK: 'viewPlayerVerifyCheck',
  PLAYER_PASSWORD_CHANGE_CHECK: 'viewPlayerPasswordChangeCheck',
  PLAYER_EMAIL_VERIFY_CHECK: 'viewPlayerEmailVerifyCheck',
  PLAYER_CELLPHONE_VERIFY_CHECK: 'viewPlayerCellPhoneVerifyCheck',
  PLAYER_2FA_CHECK: 'viewPlayer2FACheck',
  PLAYER_MESSAGE_SEND_BTN: 'viewPlayerMessageSend',
  PLAYER_PRIVATE_INFO_NAV: 'viewPlayerPrivateInfoNav',
  PLAYER_RESTRICTIONS_NAV: 'viewPlayerRestrictionsNav',
  PLAYER_BET_LIMIT_BTN: 'viewPlayerBetLimit',
  PLAYER_DOCUMENT_IMAGE_NAV: 'viewPlayerDocumentImageNav',
  PLAYER_NOTE_NAV: 'viewPlayerNoteNav',
  PLAYER_MESSAGE_NAV: 'viewPlayerMessageNav',
  PLAYER_BONUSES_NAV: 'viewPlayerBonusesNav',
  SET_DEPOSIT_ROLLOVER: 'setDepositRollOver',
  PLAYER_TRANSACTIONS_NAV: 'viewPlayerTransactionsNav',
  PLAYER_BLOCK_HISTORY_NAV: 'viewPlayerBlockHistoryNav',
  PLAYER_CHANGE_HISTORY_NAV: 'viewPlayerChangeHistoryNav',
  PLAYER_BANK_INFO_NAV: 'viewPlayerBankInfoNav',
  PLAYER_BANK_ACCOUNTS_NAV: 'viewPlayerBankAccountsNav',
  PLAYER_BANK_ACCOUNT_HISTORY_NAV: 'viewPlayerBankAccountHistoryNav',
  PLAYER_BANK_ACCOUNT_TOGGLE_BTN: 'viewPlayerBankAccountToggleBtn',
  PLAYER_PERSONAL_INFO_SECTION: 'viewPlayerPersonalInfoSection',
  PLAYER_OTHER_INFO_TAB: 'viewPlayerOtherInfoTab',
  PLAYER_PERSONAL_INFO_TAB: 'viewPlayerPersonalInfoTab',
  PLAYER_CONTACT_INFO_TAB: 'viewPlayerContactInfoTab',
  MESSAGE_PLAYERS_WITH_AGENT: 'messagePlayersWithAgent',

  PROMOTIONAL_TOOLS_BONUS_ADD_BTN: 'viewBonusAdd',
  PROMOTIONAL_TOOLS_BONUS_EDIT_BTN: 'viewBonusEdit',
  PROMOTIONAL_TOOLS_BONUS_PAUSE_BTN: 'viewBonusPause',
  PROMOTIONAL_TOOLS_BONUS_CLONE_BTN: 'viewBonusClone',
  PROMOTIONAL_TOOLS_CODES_ADD_BTN: 'viewPromotionalCodesAdd',
  PROMOTIONAL_TOOLS_CODES_SEND_IN_BULK_BTN: 'viewSendPromotionalCodesInBulk',
  PROMOTIONAL_TOOLS_CODES_EDIT_BTN: 'viewPromotionalCodesEdit',

  USER_MANAGEMENT_USERS_ADD_BTN: 'viewUserAdd',
  USER_MANAGEMENT_USERS_EDIT_BTN: 'viewUserEdit',
  USER_MANAGEMENT_USERS_UPDATE_PASSWORD_BTN: 'viewUserUpdatePassword',
  USER_MANAGEMENT_USERS_BLOCK_BTN: 'viewUserBlock',
  USER_MANAGEMENT_USERS_BLOCK_HISTORY_BTN: 'viewUserBlockHistory',
  USER_MANAGEMENT_AGENT_ADD_BTN: 'viewAgentAdd',
  USER_MANAGEMENT_AGENT_EDIT_BTN: 'viewAgentEdit',
  VIEW_AGENT_SENSITIVE_DATA: 'viewAgentSensitiveData',
  USER_MANAGEMENT_AGENT_UPDATE_PASSWORD_BTN: 'viewAgentUpdatePassword',
  USER_MANAGEMENT_AGENT_BET_LIMIT_BTN: 'viewAgentBetLimit',
  USER_MANAGEMENT_AGENT_BLOCK_BTN: 'viewAgentBlock',
  USER_MANAGEMENT_AGENT_BLOCK_HISTORY_BTN: 'viewAgentBlockHistory',
  USER_MANAGEMENT_AGENT_TRANSACTIONS_TAB: 'viewAgentTransactionsTab',
  USER_MANAGEMENT_AGENT_TRANSACTIONS_TAB_ALL: 'viewAgentTransactionsTabAll',
  USER_MANAGEMENT_AGENT_TRANSACTIONS_TAB_AGENTS: 'viewAgentTransactionsTabAgents',
  USER_MANAGEMENT_AGENT_TRANSACTIONS_TAB_PLAYERS: 'viewAgentTransactionsTabPlayers',
  USER_MANAGEMENT_AGENT_BONUS_TAB: 'viewAgentBonusTab',
  USER_MANAGEMENT_AGENT_NETWORK_TAB: 'viewAgentNetworkTab',
  USER_MANAGEMENT_AGENT_TRANSACTIONS_AGENTS: 'viewAgentTransactionsAgents',
  USER_MANAGEMENT_AGENT_TRANSACTIONS_PLAYERS: 'viewAgentTransactionsPlayers',
  USER_MANAGEMENT_COLLABORATOR_AGENTS_ADD_BTN: 'viewCollaboratorAgentAdd',
  USER_MANAGEMENT_COLLABORATOR_AGENTS_EDIT_BTN: 'viewCollaboratorAgentEdit',
  USER_MANAGEMENT_COLLABORATOR_AGENTS_UPDATEPASSWORD_BTN: 'viewCollaboratorAgentUpdatePassword',
  USER_MANAGEMENT_COLLABORATOR_AGENTS_BLOCK_BTN: 'viewCollaboratorAgentBlock',
  USER_MANAGEMENT_COLLABORATOR_AGENTS_BLOCK_HISTORY_BTN: 'viewCollaboratorAgentBlockHistory',
  GENERAL_REPORTS_EXPORT_USER_BTN: 'viewGeneralReportUserExportCsv',
  GENERAL_REPORTS_EXPORT_PLAYER_BTN: 'viewGeneralReportPlayerExportCsv',
  GENERAL_REPORTS_EXPORT_PRODUCT_BTN: 'viewGeneralReportProductExportCsv',
  REPORTS_SPORTS_BETTING_EXPORT_BET_BTN: 'viewReportSportsBettingBetExportBtn',
  REPORTS_SPORTS_BETTING_DOWNLOAD_TICKET_BTN: 'viewReportSportsBettingDownloadTicketBtn',
  CANCEL_BET_BUTTON: 'seeCancelBetButton',
  REPORTS_CASINO_BET_EXPORT_BTN: 'viewReportsCasinoBetExportBtn',
  REPORTS_CASINO_DOWNLOAD_TICKET_BTN: 'viewReportsCasinoDownloadTicketBtn',
  REPORT_LOADS_WITHDRAWALS_AGENT_EXPORT_BTN: 'viewReportLoadsAndWithdrawalsAgentExportBtn',
  EXPORT_EXCEL_SORTI: 'exportExcelSorti',
  EXPORT_EXCEL_TRANSACTION_REPORTS: 'exportExcelTransactionReports',

  RESOLVE_PENDING_BETS_BY_DATE_RANGE: 'resolvePendingBetsByDateRange',

  ANNOUNCEMENTS: 'announcements',
  ANNOUNCEMENTS_LIST: 'announcementsList',
  ANNOUNCEMENTS_CREATE_BTN: 'announcementsCreate',
  ANNOUNCEMENTS_EDIT_BTN: 'announcementsEdit',
  ANNOUNCEMENTS_STATE_BTN: 'announcementsChangeState',
  ANNOUNCEMENTS_VIEW_INFORMATION_ADVANCED: 'announcementsViewInformationAdvanced',

  AUDIT: 'audit',
  AUDIT_LOGS: 'auditLogsPage',
  MEDIA_LIBRARY: 'mediaLibrary',

  QR_PROMOS: 'qrPromos',
  QR_PROMOS_SHORT_LINKS: 'qrPromosShortLinks',
  QR_PROMOS_SHORT_LINKS_ADD_BTN: 'qrPromosShortLinksAdd',
  QR_PROMOS_SHORT_LINKS_EDIT_BTN: 'qrPromosShortLinksEdit',
  QR_PROMOS_SHORT_LINKS_STATE_BTN: 'qrPromosShortLinksState',
};

export const ROLE_TYPE = {
  SUPER_ADMIN: 'Super Admin',
};

export const DEFAULT_TIMES = {
  START: '00:00:00',
  END: '23:59:59',
  YEAR_MONTH_DAY_FORMAT: 'yyyy-MM-dd',
  START_FORMAT_DATE_TIME: 'yyyy-MM-dd 00:00:00',
  END_FORMAT_DATE_TIME: 'yyyy-MM-dd 23:59:59',
};

export const ROUTES = {
  ALL_TRASACTIONS: 'all-transactions',
  AGENTS_TRANSACTIONS: 'agents-transactions',
  PLAYERS_TRANSACTIONS: 'players-transactions',
  DEPOSIT_REQUEST: 'deposit-request',
  PHYSICAL_TRANSACTION_POINTS: 'physical-transaction-points',
};

export const APP_USER_TYPES = [
  {
    value: 'admin',
    label: 'words.admin',
  },
  {
    value: 'agent',
    label: 'words.agent',
  },
  {
    value: 'cashdesk',
    label: 'words.cashdesk',
  },
  {
    value: 'collaboratorAgent',
    label: 'words.collaboratorAgent',
  },
  {
    value: 'collaboratorOperator',
    label: 'words.collaboratorOp',
  },
  {
    value: 'guest',
    label: 'words.guest',
  },
];

export const PRODUCT_TYPE = {
  SPORT: 'Sports',
  VIRTUAL_BETS: 'Virtuals Bets',
};

export const MAX_OF_ACCOUNTS_PER_PLAYER = 3;
export const LIMIT_TYPE_BY_USER = {
  INTERVAL: 'interval',
  RANGE: 'range',
};

export const USER_TYPE_LIMIT = {
  PLAYER: 'Player',
  AGENT: 'User',
};

export const BET_LIMIT_FORM_DEFAULT = {
  limitType: LIMIT_TYPE_BY_USER.INTERVAL,
  maxAmount: null,
  intervalDays: '',
  rangeStart: '',
  rangeEnd: '',
};

export const USER_BET_LIMIT_DEFAULT: UserBetLimit = {
  _id: '',
  userId: '',
  userType: '',
  maxAmount: 0,
  limitType: 'players.player.betLimits.noneInfo',
  rangeStart: '',
  rangeEnd: '',
  intervalDays: '',
  createdAt: '',
  updatedAt: '',
  creationDateForRestart: ' ',
  isActive: false,
  __v: 0,
};

export const DASHBOARD_ROUTES = {
  AGENTS: '/user-management/agents',
  ACTIVE_PLAYERS: '/players/active-players-list',
  PLAYERS_LIST: '/players/players-list',
  BETTING_REPORT: '/reports/betting',
};

export const RESPONSE_CODES = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const TYPE_BONUS = {
  FREE_SPIN: 'free_spin',
  FREE_BET: 'free_bet',
  MANUAL: 'manual',
  DEPOSIT: 'deposit',
  LOYALTY: 'loyalty',
};

export type UserType =
  | 'admin'
  | 'agent'
  | 'cashdesk'
  | 'collaboratorAgent'
  | 'collaboratorOperator'
  | string;

export const DEFAULT_ROLES_TO_HIDE_LIST: readonly UserType[] = [
  'agent',
  'collaboratorAgent',
  'collaboratorOperator',
];

export const DEFAULT_ROLES_TO_HIDE_SET: ReadonlySet<UserType> = new Set(DEFAULT_ROLES_TO_HIDE_LIST);

export const USER_TYPE_LIST = {
  AGENT: 'agent',
  COLLABORATOR_AGENT: 'collaboratorAgent',
  COLABORATOR_OPERATOR: 'collaboratorOperator',
  CASHDESK: 'cashdesk',
};

export const AUDIT_LOG_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  DEFAULT: 'N/A',
} as const;

export const ALL_OPTION_LANG = {
  esLang: 'es',
  esAll: 'Todos',
  usAll: 'All',
};

export const DATE_RANGE_PRESETS = {
  MONTH: 'month',
  LAST_MONTH: 'lastMonth',
  WEEK: 'week',
} as const;

export const TRANSACTION_FILTER_MODES = {
  SIMPLE: 'simple',
  ADVANCED: 'advanced',
} as const;

export const TRANSACTION_FILTER_MODE_STORAGE_KEY = 'agentTransactionsFilterMode';
